import axiosConfig from "./axiosConfig";

export interface InvoicePreviewResponse {
  month: string;
  siteName: string;
  siteId: string;
  currencyCode: string;
  consumptionKwh: number;
  onSiteTariffRate: number;
  vatRate: number;
  consumptionCharges: number;
  otherCharges: number;
  subtotal: number;
  vatAmount: number;
  total: number;
  tenantName: string;
  isOO?: boolean;
  generatedKwh?: number;
  gridExportKwh?: number;
  spillTariffRate?: number;
  ooRevenueSharePct?: number;
  ooRevenueShareAmount?: number;
}

const getSiteInvoicePreview = async (
  authToken: string,
  siteId: string,
  month: string
): Promise<InvoicePreviewResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/invoice/preview?month=${encodeURIComponent(month)}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteInvoicePreview;
